var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"slide-fade"}},[(_vm.visible)?_c('div',{staticClass:"content-wrapper"},[(_vm.unwrap)?_c('div',{staticClass:"unwrap"},[_vm._t("default")],2):_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }